import { render, staticRenderFns } from "./_createPrivateTaskModal.vue?vue&type=template&id=22c0483e&"
import script from "./_createPrivateTaskModal.vue?vue&type=script&lang=js&"
export * from "./_createPrivateTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports